import axiosInstance from './../axiosInstance';

/**
 * @name getProspectumLiveAnalytics
 * @desc Get ProspectumLIVE analytics for partner
 * @param {string} eventID
 * @param {string} partnerID
 */
export const getProspectumLiveAnalytics = (eventID, partnerID) => {
  return axiosInstance.get(`events/${eventID}/partners/${partnerID}/prospectumliveAnalytics`);
};